import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcRsvdApi = async (
    gameSvcCd:string|null,
) => {
    return await CommApiInstance.post(`memb/${gameSvcCd}/rsvd/contact`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data.apiBody);
}
export default GameSvcRsvdApi;